import { render, staticRenderFns } from "./NewRoute.vue?vue&type=template&id=55dcbcb9&scoped=true"
import script from "./NewRoute.vue?vue&type=script&lang=js"
export * from "./NewRoute.vue?vue&type=script&lang=js"
import style0 from "./NewRoute.vue?vue&type=style&index=0&id=55dcbcb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dcbcb9",
  null
  
)

export default component.exports